import React, { useState } from 'react';
import moment from 'moment';
import axios from 'axios';
import { Button } from 'react-bootstrap';
import MonthSelector from '../../../common/components/MonthSelector';
import { Icon } from '../../../common/components/Utilities';
import RestrictedContent from '../../../common/components/RestrictedContent';

function SupportCsv({ groups, csrfToken }) {
  const [loading, setLoading] = useState(false);
  const [csvDate, setCsvDate] = useState(moment().subtract(1, 'month').startOf('month'));

  const getCsv = async () => {
    setLoading(true);

    try {
      const payload = {
        date: csvDate.format('YYYY-MM-DD'),
      };

      await axios.post('/support/accounting-csv', payload, {
        headers: {
          'X-CSRF-Token': csrfToken,
        },
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `ooh-${csvDate.format('MMM-YY')}.csv`);
        document.body.appendChild(link);
        link.click();
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <RestrictedContent group={groups.OPERATIONS}>
      <div className="mb-2">
        <MonthSelector value={csvDate} onChange={setCsvDate} />
      </div>
      <Button variant="outline-primary" block disabled={loading} onClick={getCsv} className="mb-2 text-left">
        <Icon icon="file-csv" variant="fad" append="mr-2" />
        {' '}
        Download Accounting CSV for
        {' '}
        {csvDate.format('MMM')}
      </Button>
    </RestrictedContent>
  );
}

export default SupportCsv;
